/*
 * @Date: 2024-12-16 10:24:40
 * @LastEditors: chris shixu.guo@tcl.com
 * @LastEditTime: 2024-12-17 09:10:41
 * @FilePath: /front-end-businessweb/src/router/modules/unemployedRouter.js
 */

const unemployedList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/Unemployed/list')),
    'unemployedList'
  );
const unemployedInput = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/Unemployed/input.vue')),
    'unemployedInput'
  );

// 假设您有一个布局组件，比如 UnemployedLayout.vue
const UnemployedLayout = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/Unemployed/layout')),
    'unemployedLayout'
  );

const unemployedRouter = {
  path: '/unemployed', // 为父路由指定一个具体路径
  name: '居代业管理',
  component: UnemployedLayout, // 使用布局组件
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
  },
  redirect: '/unemployedList', // 重定向到子路由
  children: [
    {
      path: '/unemployedList', // 相对路径
      component: unemployedList,
      name: '居代业管理',
      meta: { right: [], isShowMenu: false, keepAlive: false },
    },
    {
      path: '/unemployedInput', // 相对路径
      component: unemployedInput,
      name: '居代业信息',
      meta: { right: [], isShowMenu: false, keepAlive: false },
    },
  ],
};

export default unemployedRouter;
